"use client"

import React from 'react';
import styles from "./Infos.module.css";
import {Info as InfoType} from "@/types/Infos";

export default function Info(props: { info: InfoType }) {
  const {value, suffix, icon} = props.info
  if (props.info.label === "duration" && Array.isArray(value)) {
    if (value.every(itm => {
        return itm === 0
      }
    )) {
      return
    }
    return <p className={styles.singleInfoWrapper}>{icon} {value.map((itm, key) => {
      const label = key === 0 ? 'd' : key === 1 ? 'h' : 'm'
      return itm + label
    })}</p>
  }
  if (value === "0.00" || value === "0") return
  return <p className={styles.singleInfoWrapper}>{icon} {value} {suffix && <small> {suffix}</small>}</p>
}
